/**
 * Which zone a site's times are read in (Sprint 084.0, ADR-0091; D1).
 *
 * The zone comes from the project's address, through its country: the
 * country's profile names its IANA zones and the first is the default
 * (ADR-0084 Rule 2). This package is handed that list — it never names a zone
 * of its own, which the compliance test holds it to.
 *
 * With no list — country "Other", or no profile installed — the site still has
 * a longitude, and 15° is an hour. That is **mean solar time**, not a civil
 * zone: no summer time, and a clock that may disagree with the one on the wall
 * by an hour or more. It is returned as `approximate`, and every surface that
 * shows it says so (the same honesty ADR-0085 applies to a north with no
 * georeference). The sun's position for that instant is still exact; only the
 * reading of "14:30" is approximate.
 */
import { isKnownZone } from './time.js';
export function resolveTimeZone(timeZones, longitude) {
    const named = timeZones?.[0];
    if (named !== undefined && isKnownZone(named)) {
        return { zone: { kind: 'iana', name: named }, approximate: false };
    }
    // One degree of longitude is four minutes of time, rounded to the minute.
    return { zone: { kind: 'offset', minutes: Math.round(longitude * 4) }, approximate: true };
}
//# sourceMappingURL=zone.js.map